import React from 'react';
import SubMenuPanel from '../../components/light/common/SubMenuPanel';
import './SubMenuDemo.css';

export default function SubMenuDemo() {
  // Example: Services submenu
  const servicesMenu = [
    {
      key: 'web',
      label: 'Web Development',
      to: '/services/web-development',
    },
    {
      key: 'design',
      label: 'Design Services',
      to: '/services/design',
    },
    {
      key: 'marketing',
      label: 'Digital Marketing',
      to: '/services/marketing',
    },
  ];

  // Example: AI submenu (like in your navbar)
  const aiMenu = [
    {
      key: 'videos',
      label: 'Videos',
      to: '/light/page-ai-videos',
    },
    {
      key: 'model',
      label: 'Model Shoot',
      to: '/light/page-ai-model-shoot',
    },
    {
      key: 'product',
      label: 'Product Shoot',
      to: '/light/page-ai-product-shoot',
    },
  ];

  return (
    <div className="submenu-demo">
      <div className="demo-section">
        <h2>Services Submenu Example</h2>
        <p>Hover over the menu items to see suboptions in the right panel:</p>
        <SubMenuPanel items={servicesMenu} />
      </div>

      <div className="demo-section">
        <h2>AI Services Submenu Example</h2>
        <p>This is the submenu used in your navbar for AI services:</p>
        <SubMenuPanel items={aiMenu} />
      </div>

      <div className="demo-info">
        <h3>How to Use</h3>
        <pre>{`import SubMenuPanel from '../../components/light/common/SubMenuPanel';

const menuItems = [
  {
    key: 'item-key',
    label: 'Item Label',
    to: '/path/to/page',
  },
  {
    key: 'item-key-2',
    label: 'Another Item',
    to: '/another/path',
  },
];

<SubMenuPanel items={menuItems} />`}</pre>
      </div>
    </div>
  );
}
